var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"appRef",attrs:{"id":"index"}},[_c('div',{attrs:{"id":"china-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }